import { render, staticRenderFns } from "./ExamGroupEditor.vue?vue&type=template&id=6ee4c4a8&scoped=true&"
import script from "./ExamGroupEditor.vue?vue&type=script&lang=ts&"
export * from "./ExamGroupEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExamGroupEditor.vue?vue&type=style&index=0&id=6ee4c4a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee4c4a8",
  null
  
)

export default component.exports